<template>
  <div class="flex-row border-b dark:border-warm-gray-700 mt-8">
    <!-- <div class="flex justify-start items-center mb-8">
      <h2 class="text-xl font-extrabold text-warm-gray-700 dark:text-warm-gray-100 tracking-wider">Reviewers Data</h2>
    </div> -->

    <div class="flex justify-between px-8 items-center">
      <router-link to="/reviewers">
        &larr; Back To Reviewers
      </router-link>
      <ul v-if="!retrieving && this.$route.query.r && reviewerSet" class="flex justify-start">
        <li v-for="(tab,i) in tabs" :key="i" :class="[view == tab.viewId && 'border-b-4 border-yellow-600']">
          <router-link :to="tab.to+'?r='+curRevId">
            <button class="py-2 px-4 focus:outline-none">
              {{tab.name}}
            </button>
          </router-link>
        </li>
      </ul>
      <template v-if="reviewers.data">
        <select class="border-b border-warm-gray-500 border-0 focus:outline-none focus:ring-0 text-warm-gray-800 dark:text-warm-gray-200 bg-transparent py-1 ml-2" v-model="curRevId">
          <option v-for="reviewer in reviewers.data.reviewers" :value="reviewer.id" class="text-warm-gray-800">{{ reviewer.data.name }}</option>
        </select>        
      </template>
    </div>

    
    

  </div>
  <router-view v-if="!retrieving && this.$route.query.r && reviewerSet"/>
  <div v-if="retrieving" class="flex justify-center items-center mt-10">
    <SpinningIcon class="h-6 w-6 text-yellow-600" />
  </div>
</template>

<script>
import { getAll } from '../modules/reviewer/firebase';
import SpinningIcon from '@/components/SpinningIcon';

 // test for git stash
export default {
  data() {
    return {
      isMounted: false,
      retrieving: false,
      reviewers: [],
      reviewerSet: true,
      curRevId: null,
      view:'',
      activeTab: 'questionnaires',
      tabs: [
        {
          viewId: 'questionnaires',
          name: 'Questionnaires',
          to: '/data/questionnaires',
        },
        {
          viewId: 'courses',
          name: 'Courses',
          to: '/data/courses',
        },
        {
          viewId: 'subjects',
          name: 'Subjects',
          to: '/data/subjects',
        },
        {
          viewId: 'subtopics',
          name: 'Subtopics',
          to: '/data/subtopics',
        },
        {
          viewId: 'tags',
          name: 'Tags',
          to: '/data/tags',
        },
        {
          viewId: 'explanations',
          name: 'Explanations',
          to: '/data/explanations',
        },
      ],
    }
  },
  components:{
    SpinningIcon,
  },
  updated() {
    const curPath = this.$route.path;
    this.view = curPath.split('/')[2];
    if (this.isMounted) {
      this.setReviewerId();
    }
  },
  watch:{
    curRevId(newVal, oldVal){
      // Only redirect if:
      // 1. This is not the initial mount (oldVal is not null)
      // 2. The new value is different from the current query parameter
      // 3. The component is already mounted
      if (oldVal !== null && newVal !== this.$route.query.r && this.isMounted) {
        this.$router.push('/data/questionnaires?r='+newVal);
      }
    }
  },
  async mounted() {
    
    this.retrieving = true;

    const curPath = this.$route.path;
    this.view = curPath.split('/')[2];
    this.reviewers = await getAll();

    console.log('====>', this.reviewers.data);

    // check if there is a reviewer added already
    if(this.reviewers.data.reviewers.length > 0){
      // Check if query parameter "r" exists, if so use it, otherwise use first reviewer
      if (this.$route.query.r) {
        // Validate that the reviewer ID from query parameter exists
        const foundReviewer = this.reviewers.data.reviewers.find(r => r.id == this.$route.query.r);
        if (foundReviewer) {
          this.curRevId = this.$route.query.r;
        } else {
          alert('Reviewer ID not found!');
          this.reviewerSet = false;
          this.retrieving = false;
          return;
        }
      } else {
        // No query parameter, use first reviewer and set it
        this.curRevId = this.reviewers.data.reviewers[0].id;
        this.$router.push(this.$route.path+'?r='+this.curRevId);
      }
    }else{
      this.reviewerSet = false;
      alert('Please add reviewer first!');
      this.$router.push('/reviewers');
      this.retrieving = false;
      return;
    }

    this.retrieving = false;
    this.isMounted = true;
  },
  methods: {
    setReviewerId(){
      console.log('??====>', this.$route.query.r);
      
      // If no query parameter, redirect to first reviewer
      if (!this.$route.query.r) {
        this.$router.push(this.$route.path+'?r='+this.reviewers.data.reviewers[0].id);
        return;
      }

      // Sync curRevId with query parameter
      const queryReviewerId = this.$route.query.r;
      
      // Check if the reviewer ID from query parameter is valid
      const foundReviewer = this.reviewers.data.reviewers.find(r => r.id == queryReviewerId);
      
      if (!foundReviewer) {
        alert('Reviewer ID not found!');
        this.reviewerSet = false;
        return;
      }

      // Update curRevId to match query parameter if different
      if (this.curRevId !== queryReviewerId) {
        this.curRevId = queryReviewerId;
      }
    }
  },
}
</script>